/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const Guidelines = () => {
  return (
    <div className="mx-auto container">
      <div className="lg:px-40 md:px-16 my-5">
        <div className="p-8 lg:p-12 bg-white rounded-lg shadow-md lg:mx-40">
          <h2 className="text-2xl font-bold">IntroSend Community Guidelines</h2>
          <div className="my-5 shadow bg-gray-100 p-3">
            These guidelines are here to make sure everyone is comfortable with IntroSend and is
            treated with respect.
          </div>

          <div className="my-5">
            IntroSend exists to help you make friends and to promote community networking. It’s not
            a place to spam other members with requests to refer you for jobs, hire them, or
            anything else.
          </div>

          <div className="my-5">
            <ol>
              <li className="my-3">
                1. <strong>Discrimination of any kind won’t be tolerated.</strong> If you see
                discrimination, hate, abuse, or threats of any kind, please report it to Rishab or
                Marcel. We don’t hold back on this. They’ll be banned from the IntroSend community
                immediately. Discussions, posts, actions, or comments that promote hatred of any
                kind are not acceptable through communication on IntroSend or during meetings.
              </li>
              <li className="my-3">
                2. <strong>No unsolicited pitches.</strong> In other words: don’t ask other members
                to refer/hire you unless they’ve openly stated they’re looking for someone to
                refer/hire.
              </li>
              <li className="my-3">
                3. <strong>Adhere to community guidelines.</strong> Along with IntroSend, certain
                communities can add their own guidelines specific to their own communities.
                IntroSend encourages its members to adhere to the individual community guidelines
              </li>
              <li className="my-3">
                4. <strong>Treat IntroSend introductions with respect.</strong> Treat your intros
                like you would treat introductions from a friend or trusted colleague.
              </li>
              <li className="my-3">
                5. <strong>Respond in a timely manner</strong> to introduction emails for the week,
                and communicate in a friendly and professional way.
              </li>
              <li className="my-3">
                6. <strong>Ghosting is discouraged.</strong> Emergencies happen — in those cases,
                let your match know if you can't make a meeting ASAP. “Ghosting”, or not showing up
                to a scheduled meeting without notifying your match, is bad practice and not a great
                experience for any of us.
              </li>
              <li className="my-3">
                7. <strong>Update your profile tastefully</strong> or according to community
                standards. We understand every community is unique. Make sure your profile reflects
                the value you bring to your community.
              </li>
              <li className="my-3">
                8. <strong>Do not expect transactional benefits.</strong> We expect friendly and
                open-ended conversations and often offer to make helpful introductions if they feel
                like there's a good fit. Take the time to build rapport with your match, and you'll
                reap the rewards.
              </li>
              <li className="my-3">
                9. <strong>Thank your intros and pay it forward.</strong> When your match spends
                their precious and valuable time giving guidance, advice, introductions, or other
                help, take the time to thank them and pay it forward when you can!
              </li>
              <li className="my-3">
                10. <strong>IntroSend is a respectful community.</strong> Reports of any
                inappropriate behavior or personal solicitation is not welcome.
              </li>
              <li className="my-3">
                11. Any recruitment activity or any company strategy to encourage existing
                distributors to recruit new distributors (commonly known as Multi-level marketing,
                or Direct Sales) is <strong>strictly prohibited.</strong> Members are encouraged to
                report this behavior to Rishab or Marcel and offenders will be promptly removed
                without warning.
              </li>
              <li className="my-3">
                12. <strong>Each of our members plays a positive role</strong> in establishing and
                promoting a positive, inclusive, and encouraging community.
              </li>
            </ol>
          </div>

          <div className="my-3">
            We prioritize working with those affected to determine what the next steps should be —
            the safety of our members is of utmost importance. If you have been subject to any of
            these behaviors please let IntroSend know.
          </div>

          <div className="my-3">
            Members found to have broken the IntroSend code of conduct will be removed from the
            platform.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guidelines;
